import { Div } from "@tblabs/truffle";
import { FormRow } from "./FormRow";


export class FormPrinter extends Div
{
    constructor(...rows: FormRow[])
    {
        super("table-container");

        this.Append(
            ...rows
        );
    }
}
